import { Alert } from "antd";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { delayNotifications } from "../../../common/utils/delayNotifications";
import { getUserDisplayName } from "../../../common/utils/userDisplayName";
import type { RootState } from "../../store";
import { statusLabelMap } from "../ticketConstants";

type Props = {
  status: string | null | undefined;
  statusBeforeDelay?: string | null;
  delayedByProject?: boolean | null;
};

export const DelayedBanner = ({ status, statusBeforeDelay, delayedByProject }: Props) => {
  const latest = useSelector(
    (state: RootState) => delayNotifications(state.ticket.ticketDelays ?? [])[0] ?? null
  );

  if (status !== "DELAYED") return null;

  const reasonText = latest?.message
    ? `${latest.message} — delayed by ${latest.sender ? getUserDisplayName(latest.sender) : "unknown"} on ${dayjs(latest.created_at).format("DD/MM/YYYY HH:mm")}`
    : "No delay reason provided";

  // A cascade from the project is undone by resuming the project, not this work order,
  // so the banner names the project as the source rather than leaving the manager to
  // continue each work order one by one.
  const sourceText = delayedByProject
    ? " · Delayed together with its project — resume the project to continue them all."
    : "";

  const restoreText =
    statusBeforeDelay && statusBeforeDelay in statusLabelMap
      ? ` · Continuing returns it to ${statusLabelMap[statusBeforeDelay]}.`
      : "";

  return (
    <Alert
      type="error"
      showIcon
      message="Work Order Delayed"
      description={`${reasonText}${sourceText}${restoreText} Technicians cannot work on it while it is delayed.`}
    />
  );
};
